"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["color", "size"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var WifiOff = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  var {
    color,
    size
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: size,
    height: size,
    fill: color
  }, rest), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("style", null, ".a{fill:none;}.b{fill:#4a4a4a;}")), /*#__PURE__*/_react.default.createElement("defs", null), /*#__PURE__*/_react.default.createElement("rect", {
    className: "a",
    width: "16",
    height: "16"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "b",
    d: "M1,0A1,1,0,1,1,0,1,1,1,0,0,1,1,0Z",
    transform: "translate(7 11.5)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "b",
    d: "M6.829,12.645a.475.475,0,0,0-.038.7l.043.042a.464.464,0,0,0,.625.034,5.974,5.974,0,0,1,3.209-1.383l1.021-1.021,0-.009A6.961,6.961,0,0,0,6.829,12.645Z",
    transform: "translate(-3.327 -5.5)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "b",
    d: "M2.583,8.259a.474.474,0,0,0,.655.013,8.889,8.889,0,0,1,8.08-2.009l.822-.821a9.974,9.974,0,0,0-9.585,2.1.468.468,0,0,0-.014.674Z",
    transform: "translate(-1.202 -2.5)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "b",
    d: "M15.851,6.246a10.087,10.087,0,0,0-1.738-1.236l1.741-1.742a.5.5,0,1,0-.707-.707L2.561,15.147a.5.5,0,1,0,.707.707l4.988-4.987a2.963,2.963,0,0,1,2.7.408.465.465,0,0,0,.6-.048l.042-.042a.472.472,0,0,0-.052-.714A3.978,3.978,0,0,0,9.4,9.717L11.1,8.023a6.012,6.012,0,0,1,1.951,1.085A.477.477,0,0,0,13.7,9.09l.042-.041a.475.475,0,0,0-.037-.7,7.038,7.038,0,0,0-1.826-1.1l1.5-1.5a9.06,9.06,0,0,1,1.8,1.23.472.472,0,0,0,.649-.012l.045-.044A.467.467,0,0,0,15.851,6.246Z",
    transform: "translate(-1.207 -1.207)"
  }));
});
WifiOff.propTypes = {
  color: _propTypes.default.string,
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  onClick: _propTypes.default.func
};
WifiOff.defaultProps = {
  color: 'currentColor',
  size: '1em',
  onClick: () => {}
};
var _default = WifiOff;
exports.default = _default;